import $ from 'jquery';
import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import 'next/stylesheets/components/todolist-plus';
import Sortable from 'sortablejs';
import { closest } from 'next/javascripts/modules/dom';

Component('tr-todolist-plus', {
  mixins: [eventListenerMixin],

  properties: {
    sortUrl: {
      type: String,
    },
  },

  ready() {
    if (this.sortUrl) {
      this.initSortTodo();
    }
  },

  initSortTodo() {
    Sortable.create(this, {
      group: 'my-todo',
      sort: true,
      draggable: 'tr-todo-item-plus:not([editing])',
      handle: '.todo-content',
      animation: 0,
      delay: 50,
      ghostClass: 'ghost',
      forceFallback: (window.gon && window.gon.sortableFallback) || false,
      onChoose: () => {
        this.namespacedTrigger('sortableChoose', { bubbles: true });
      },
      onUnchoose: () => {
        this.namespacedTrigger('sortableUnchoose', { bubbles: true });
      },
      onMove: (event) => {
        this.namespacedTrigger('sortableMove', {
          detail: { originalEvent: event },
          bubbles: true,
        });
      },
      onEnd: (event) => {
        const $todo = $(event.item);

        $.ajax({
          url: this.sortUrl,
          type: 'post',
          data: {
            box: closest(event.item, '.box').dataset.box,
            todoGuid: event.item.guid,
            prevTodoGuid: $todo.prev('tr-todo-item-plus').attr('guid'),
            nextTodoGuid: $todo.next('tr-todo-item-plus').attr('guid'),
          },
        });

        this.namespacedTrigger('sortableEnd', {
          detail: { originalEvent: event },
          bubbles: true,
        });
      },
    });
  },

  disconnected() {
    this.stopListening();
  },
});
